<template>
  <div>
    <div class="home-page">
      <div class="bg"></div>
      <div v-if="type === 1" class="content">
        <img class="img" src="./../../assets/home/xwj1.png" alt="" />
        <div class="imgFix1" @click="handleShow"></div>
        <div class="txt mt65">点击底部按钮即可旋转模型查看发光点</div>
        <div class="txt">点击发光点连接电源</div>
      </div>
      <div v-if="type === 2" class="content">
        <img class="img" src="./../../assets/home/xwj2.png" alt="" />
        <div class="imgFix2" @click="handleShow"></div>
        <div class="txt mt65">点击底部按钮即可旋转模型查看发光点</div>
        <div class="txt">点击发光点下放载物台</div>
      </div>

      <div v-if="type === 3" class="content">
        <img class="img" src="./../../assets/home/xwj3.png" alt="" />
        <div class="imgFix3" @click="handleShow"></div>
        <div class="txt mt65">点击底部按钮即可旋转模型查看发光点</div>
        <div class="txt">点击发光点复位至低倍镜</div>
        <div class="txt">并进入下一步考核</div>
      </div>
      <div class="footer">
        <div @click="handlePrev" class="left">
          <img src="./../../assets/home/leftIcon.png" alt="" />
          左转
        </div>
        <div @click="handleNext" class="right">
          右转
          <img src="./../../assets/home/leftIcon.png" alt="" />
        </div>
      </div>
    </div>
    <van-dialog
      v-model="imgAmplify"
      :showConfirmButton="false"
      className="dialogImg"
    >
      <div class="imgAmplify">
        <img v-if="type === 1" src="./../../assets/home/01.gif" alt="" />
        <img v-if="type === 3" src="./../../assets/home/02.gif" alt="" />
        <img v-if="type === 2" src="./../../assets/home/03.gif" alt="" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "Home2026",
  data() {
    return {
      type: 1,
      imgAmplify: false,
      imgStatus: false,
      count: "",
      isShowTimeHeader: 1,
    };
  },
  created() {},
  methods: {
    // 上一步
    handlePrev() {
      if (this.type !== 1) {
        this.type--;
      } else {
        this.$router.back();
      }
    },

    // 下一步
    handleNext() {
      if (this.type !== 3) {
        this.type++;
      } else {
        this.$router.replace("/microscope/slide");
      }
    },

    // 打开弹出gif图
    handleShow() {
      this.imgAmplify = true;
      this.countDown();
    },

    // 倒计时
    countDown() {
      const timeCount = 3;
      if (!this.timer) {
        this.count = timeCount;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= timeCount) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.isShowTimeHeader = 0;
            this.imgAmplify = false;
            if (this.type === 3) {
              this.$router.replace("/microscope/slide");
            }
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    min-height: calc(100vh - 90px);
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 1px;
    position: relative;
    .img {
      display: block;
      width: 610px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .imgFix1 {
      width: 120px;
      height: 120px;
      position: absolute;
      top: 700px;
      right: 140px;
    }
    .imgFix2 {
      width: 120px;
      height: 120px;
      position: absolute;
      top: 660px;
      right: 70px;
    }
    .imgFix3 {
      width: 120px;
      height: 120px;
      position: absolute;
      top: 480px;
      right: 270px;
    }
    .txt {
      line-height: 50px;
      font-size: 32px;
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
    }
    .mt65 {
      margin-top: 65px;
    }
  }
  .footerSeize {
    height: 143px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 650px;
    height: 143px;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    padding: 40px 50px 0 50px;
    display: flex;
    .left {
      width: 310px;
      height: 88px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      img {
        width: 40px;
        margin-left: 48px;
        margin-right: 64px;
        vertical-align: middle;
      }
    }
    .right {
      width: 310px;
      height: 88px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      margin-left: 30px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      text-indent: 64px;
      img {
        width: 40px;
        margin-left: 64px;
        margin-right: 48px;
        vertical-align: middle;
      }
    }
  }
}
::v-deep .van-dialog {
  border-radius: 0;
  width: 98%;
  background: none;
  .van-dialog__content {
    width: 100%;
  }
  .imgAmplify {
    width: 80%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
</style>
